import { useState } from "react";

import { WrenchIcon } from "lucide-react";
import { Button, type ButtonProps, type ModalProps } from "reactstrap";

import { LandingPageEditorFormWrapper } from "./LandingPageEditorFormWrapper";

interface LandingPageEditorModalButtonProps {
  campaignId: string;
  buttonProps?: ButtonProps;
  modalProps?: ModalProps;
}

export const LandingPageEditorModalButton = ({
  campaignId,
  buttonProps,
  modalProps,
}: LandingPageEditorModalButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  // const handleSave = (content: string) => {
  //   onSave(content);
  //   handleClose();
  // };

  return (
    <>
      <Button
        color="primary"
        outline
        size="sm"
        className="d-flex align-items-center gap-2"
        onClick={handleOpen}
        {...buttonProps}
      >
        <WrenchIcon size={"1.2em"} />
        Edit Landing Page
      </Button>
      <LandingPageEditorFormWrapper
        isOpen={isOpen}
        onClose={handleClose}
        // onSave={handleSave}
        campaignId={campaignId}
        {...modalProps}
      />
    </>
  );
};
